@if (projects$ | async; as projects) {
  <div class="lg:-mt-[2.75rem]">
    <div>
      <div class="flex space-x-4 justify-end" aria-label="Tabs">
        <button
          class="px-3 py-1 text-sm rounded-md"
          [ngClass]="
            filter$.value === 'active'
              ? 'bg-blue-100 text-blue-700'
              : 'text-fg-secondary hover:text-fg-subtle'
          "
          (click)="filter$.next('active')"
        >
          Aktive
        </button>
        <button
          class="px-3 py-1 text-sm rounded-md"
          [ngClass]="
            filter$.value === 'inactive'
              ? 'bg-blue-100 text-blue-700'
              : 'text-fg-secondary hover:text-fg-subtle'
          "
          (click)="filter$.next('inactive')"
        >
          Inaktive
        </button>
        <button
          class="px-3 py-1 text-sm rounded-md"
          [ngClass]="
            filter$.value === 'all'
              ? 'bg-blue-100 text-blue-700'
              : 'text-fg-secondary hover:text-fg-subtle'
          "
          (click)="filter$.next('all')"
        >
          Alle
        </button>
      </div>
    </div>
  </div>
  @if (projects.length > 0) {
    <div class="mt-4 bg-surface shadow overflow-hidden sm:rounded-md">
      <ul>
        @for (project of projects; track project.id; let isFirst = $first) {
          <li
            app-project-list-entry
            [project]="project"
            (navigateTo)="navigateTo($event)"
            [ngClass]="{ 'border-t border-edge': !isFirst }"
          ></li>
        }
      </ul>
    </div>
  } @else {
    <app-empty (buttonClick)="createProject()" message="Erstelle dein erstes Projekt"></app-empty>
  }
}
